/** sub.by site constants */
export const SITE_HOST = 'sub.by';
export const SITE_BASE_URL = `https://${SITE_HOST}/`;
/** Instagram username for support links */
export const SITE_INSTAGRAM_USER = 'sub2by';
